export default "__VITE_ASSET__bc361bdb__"